module.exports = __webpack_public_path__ + "img/los_laureles.cc45a96e.png";